var map = {
	"./2-e1687874111881.png": 5928,
	"./MCE-26334-DEST-Mykonos-Main_Sunset.jpg": 5278,
	"./PAYMENTS-BOTTOM-4.png": 8231,
	"./V-Class-Marco-Polo-1.png": 1680,
	"./What-to-do-in-Athens-Plaka.jpg": 1005,
	"./athens.jpg": 1892,
	"./emerald_green.webp": 8355,
	"./favicon.ico": 804,
	"./fleet-Mercedes-Benz-Sprinter-Passenger-Van.png": 3755,
	"./logo-1.png": 1180,
	"./luxury-tours-luxury-transfers-black-leader-athens.png": 8675,
	"./mercedes-vito_tourer_1.png": 5256,
	"./mini-bus.jpg": 9451,
	"./opt-6.jpg": 6945,
	"./pexels-jimmy-teoh-294331-951539.jpg": 1374,
	"./van.jpg": 6800,
	"./windmill-in-mykonos-greece-5132.jpg": 7204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;